import React from 'react';
import * as styles from '../css/feedback-content.css';

const FeedbackContent: React.FC = ({ children }) => (
    <div className={styles.root}>
        “
        {children}
        ”
    </div>
);

export default FeedbackContent;
